"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("normalize.css");

var _panelContext = require("./panel-context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/forbid-prop-types, no-unused-vars, import/no-unresolved, import/extensions */
var FullpageAccordion = function FullpageAccordion(_ref) {
  var children = _ref.children,
      height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement(_panelContext.PanelContextProvider, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "panels",
    "data-testid": "panels",
    style: {
      height: height || '100vh'
    }
  }, children));
};

FullpageAccordion.defaultProps = {
  height: undefined
};
FullpageAccordion.propTypes = {
  children: _propTypes["default"].node.isRequired,
  height: _propTypes["default"].string
};
var _default = FullpageAccordion;
exports["default"] = _default;